<template>
  <div>
    <div v-if="store">
      <div
        class="top"
        :style="{
          backgroundImage: `url(${require(`../assets/images/stores/${storeName}.jpg`)})`
        }"
      >
        <div class="absolute content-container">
          <div class="logo-container">
            <img src="../assets/images/store_logos/lumi_accessories.png" />
          </div>
          <h1>{{ `store.${storeName}` | translate }}</h1>
          <span>46° 50’ 58.1676’’ N | 9° 31’ 50.412’’ E</span>
        </div>
        <div class="tags">
          <div class="tag-container" v-for="(tag, i) in store.tags" :key="i">
            <div class="tag-icon"></div>
            <span class="tag">
              {{ `store_map.tooltips.${tag}` | translate }}
            </span>
          </div>
        </div>
      </div>
      <div class="content-container middle">
        <p class="store-description">
          {{ `store_page.long_descriptions.${storeName}` | translate }}
        </p>
        <div class="brands-container">
          <span class="title"
            >{{ "store_page.titles.available_at" | translate }}
            {{ `store.${storeName}` | translate }}</span
          >
          <div class="brands">
            <span class="brand">Brand</span>
            <span class="brand">BrandBrand</span>
            <span class="brand">Brand</span>
            <span class="brand">Brand</span>
            <span class="brand">BrandBrand</span>
            <span class="brand">Brand</span>
            <span class="brand">Brand</span>
            <span class="brand">Brand</span>
            <span class="brand">Brand</span>
            <span class="brand">BrandBrand</span>
            <span class="brand">Brand</span>
            <span class="brand">BrandBrand</span>
            <span class="brand">BrandBrand</span>
          </div>
        </div>
        <div class="additional-info">
          <div class="titles">
            <div
              class="title"
              @click="onMoreInfoClick"
              :class="{ active: !shippingVisible }"
            >
              {{ "product_page.titles.more_product_info" | translate }}
            </div>
            <div
              class="title"
              @click="onShippingClick"
              :class="{ active: shippingVisible }"
            >
              {{ "product_page.titles.shipping_returns" | translate }}
            </div>
          </div>
          <div class="horizontal-line"></div>
          <div v-if="!shippingVisible" class="content">
            <div class="column">
              <span>{{ "store_page.titles.opening_hours" | translate }}</span>
              <span>Day: 09:00 - 19:00</span>
              <span>Day: 09:00 - 19:00</span>
              <span>Day: 09:00 - 19:00</span>
              <span>Day: 09:00 - 19:00</span>
              <span>Day: 09:00 - 19:00</span>
            </div>
            <div v-if="store.locations[0].coordinates[0]" class="column">
              <span>{{ "store_page.titles.location" | translate }}</span>
              {{ store.locations[0].coordinates[0] }}
            </div>
          </div>
          <div v-if="shippingVisible" class="content">
            <p>
              SHIPPING Lorem ipsum dolor sit amet, consectetur adipisci elit,
              sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquid ex ea commodi consequat. Quis aute iure
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint obcaecat cupiditat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum
            </p>
          </div>
        </div>
      </div>
      <div class="content-container">
        <div class="header-vertical-line">
          <div class="flex-col">
            <h4>{{ "store_page.titles.enjoy" | translate }}</h4>
            <h4>{{ `store.${storeName}` | translate }}</h4>
          </div>
        </div>
        <product-grid :storeProp="[store.storeName]"> </product-grid>
      </div>
    </div>
    <gyra-spinner v-else></gyra-spinner>
  </div>
</template>

<script>
import { getProductsForStore, getStoreByName } from "../services/api";
import GyraSpinner from "../components/atoms/gyra-spinner";
import ProductGrid from "../components/molecules/product-grid.vue";

export default {
  name: "StorePage",
  components: {
    GyraSpinner,
    ProductGrid
  },
  data() {
    return {
      products: null,
      showCount: 20,
      store: null,
      shippingVisible: false
    };
  },
  methods: {
    async getProducts() {
      const response = await getProductsForStore(this.$route.params.store);
      this.products = response.data;
    },
    visitProductPage(product) {
      this.$router.push({
        name: "ProductPage",
        params: {
          name: product.name,
          id: product._id,
          sex: this.$route.params.sex
        }
      });
    },
    loadMoreItems() {
      this.showCount += 20;
    },
    async getStoreInfo() {
      const response = await getStoreByName(this.$route.params.store);
      this.store = response.data[0];
    },
    navigateToStoreOnMap() {
      this.$router.go(-1);
    },
    onShippingClick() {
      this.shippingVisible = true;
    },
    onMoreInfoClick() {
      this.shippingVisible = false;
    }
  },
  computed: {
    hasProducts() {
      return this.products && this.products.length > 0;
    },
    allItemsLoaded() {
      return this.products.length <= this.showCount;
    },
    productsToShow() {
      if (!this.products) return;
      const index = !this.allItemsLoaded
        ? this.showCount
        : this.products.length;
      return this.products.slice(0, index);
    },
    storeName() {
      return this.$route.params.store;
    }
  },
  mounted() {
    this.getProducts();
    this.getStoreInfo();
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.top {
  height: 50vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  margin-bottom: 2.5rem;
  position: relative;

  .absolute {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    h1 {
      color: $brand-white;
    }

    span {
      color: $brand-white;
      font-family: "Lora";
      font-weight: 700;
    }
  }

  .logo-container {
    width: 5rem;
    height: 5rem;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $brand-white;

    img {
      width: 100%;
    }
  }

  .tags {
    position: absolute;
    bottom: 1rem;
    left: 1rem;
    display: flex;

    .tag-container {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .tag-icon {
      width: 1.5rem;
      height: 1.5rem;
      border: 1px solid $brand-white;
      border-radius: 50%;
      margin-bottom: 0.5rem;
    }

    .tag {
      color: $brand-white;
      margin: 0;
      font-weight: 600;
    }
  }
}

.middle {
  margin-bottom: 2.5rem;

  .store-description {
    text-align: center;
    margin-bottom: 2.5rem;
  }

  .title {
    margin-bottom: 1rem;
    font-size: $font-m;
  }

  .brands-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    .brands {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      .brand {
        border: 1px solid $brand-black;
        border-radius: 1rem;
        display: flex;
        padding: 0.25rem 0.75rem;
        font-size: $font-sm;
        margin-right: 0.5rem;
        margin-bottom: 0.75rem;
      }
    }
  }

  .additional-info {
    .column {
      display: flex;
      flex-direction: column;
      margin-right: 2rem;

      span:first-of-type {
        margin-bottom: 1rem;
        font-weight: 700;
        color: $brand-gray-medium;
      }
    }

    .content {
      display: flex;
    }
  }
}

.header-vertical-line {
  h4 {
    font-size: 2rem;
  }
}
</style>
